import API from '../axios/API';

export const editCustomer = (customerId, data) => {
    return async () => {
        let response;

        try {
            response = await API.put(`en/pos/restaurants/:restaurantID/customers/${customerId}`, data);
        } catch (error) {
            response = error;
        }

        return response;
    };
};
